const doc = [({"da":({"js":({"shared":({"state_selector":({"state_was_updated":"Status blev opdateret"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;